// App namespaces
export const APP_NAMESPACES = ["fms", "rms"];

// Language namespaces
export const LANGUAGE_NAMESPACES = ["en", "ar"];

// Legacy support - keeping for backward compatibility
export const NAME_SPACE = ["fms", "en", "ar"];

// Auth paths //
export const LOGIN_PATH = "/admin/login";

//PROJECTS
export const PROJECTS_LISTING_PATH = "/projects";
export const PROJECTS_ADD_PATH = "/projects/add";
export const PROJECTS_EDIT_PATH = "/projects/edit/:projectId";

export const UNITS_LISTING_PATH = "/units";
export const UNIT_DETAIL_PATH = "/units/:unitId";

export const CLIENTS_LISTING_PATH = "/clients";

export const ROLES_LISTING_PATH = "/roles";
export const ROLES_EDIT_PATH = "/roles/edit/:roleId";

export const AGREEMENTS_LISTING_PATH = "/agreements";
export const EDIT_AGREEMENT = "/agreements/edit/:agreementId";
export const ADD_AGREEMENT = "/agreements/add";
export const AGREEMENT_DETAIL_PATH = "/agreements/:agreementId";

export const BILLS_LISTING_PATH = "/bills";

export const PAYMENTS_LISTING_PATH = "/payments";

export const VISITS_LISTING_PATH = "/visits";

export const DASHBOARD_PATH = "/dashboard";

export const WORK_ORDERS_LISTING_PATH = "/work-orders";

// RMS MODULES

export const BOOKINGS_LISTING_PATH = "/bookings";
export const BOOKINGS_DETAIL_PATH = "/bookings/:bookingId";
export const ADD_BOOKINGS_PATH = "/bookings/add";
export const EDIT_BOOKINGS_PATH = "/bookings/edit/:bookingId";

export const RMS_PAYMENTS_LISTING_PATH = "/payments";
export const RMS_DASHBOARD_PATH = "/dashboard-rms";

export const TASKS_LISTING_PATH = "/tasks";

export const RMS_APPROVALS_LISTING_PATH = "/approvals";
export const RECOVERY_LEADS_LISTING_PATH = "/recovery_leads";
export const RECOVERY_LEADS_DETAIL_PATH = "/recovery_leads/:recoveryLeadId";

export const REFUNDS_LISTING_PATH = "/refunds";

export const CLIENTS_DETAIL_PATH = "/clients/:clientId";

// RMS Projects
export const RMS_PROJECTS_LISTING_PATH = "/projects";
export const RMS_PROJECT_DETAIL_PATH = "/projects/:projectId";
export const RMS_ADD_PROJECT_PATH = "/projects/add";
export const RMS_EDIT_PROJECT_PATH = "/projects/edit/:projectId";

// Transfers //
export const TRANSFERS_LISTING_PATH = "/transfers";
export const ADD_TRANSFER_PATH = "/transfers/:bookingId";

export const STAFF_LISTING_PATH = "/staff";
export const STAFF_DETAIL_PATH = "/staff/:staffId";
export const ADD_STAFF_PATH = "/staff/add";

// TEAMS
export const TEAMS_LISTING_PATH = "/teams";

export const TENANT_SETTINGS_PATH = "/tenant-settings";

export const TARGETS_LISTING_PATH = "/targets";
export const ADD_TARGET_PATH = "/targets/add";
export const EDIT_TARGET_PATH = "/targets/edit";

// Developer Portal
export const DEVELOPER_INVENTORY_LISTING_PATH = "/inventory";
